import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleplayAppIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 235,
	height: 61,
	viewBox: "0 0 250 61",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M240.741 60.7646H9.25926C4.16898 60.7646 0 57.3878 0 53.2646V8.26465C0 4.14153 4.16898 0.764652 9.25926 0.764652H240.741C245.831 0.764652 250 4.14153 250 8.26465V53.2646C250 57.3878 245.831 60.7646 240.741 60.7646Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M240.741 1.96652C245.028 1.96652 248.516 4.79215 248.516 8.26465V53.2646C248.516 56.7371 245.028 59.5628 240.741 59.5628H9.25926C4.97222 59.5628 1.4838 56.7371 1.4838 53.2646V8.26465C1.4838 4.79215 4.97222 1.96652 9.25926 1.96652H240.741ZM240.741 0.764652H9.25926C4.16898 0.764652 0 4.14153 0 8.26465V53.2646C0 57.3878 4.16898 60.7646 9.25926 60.7646H240.741C245.831 60.7646 250 57.3878 250 53.2646V8.26465C250 4.14153 245.831 0.764652 240.741 0.764652Z",
			fill: "#A6A6A6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.1059 12.6095C34.6834 13.04 34.439 13.7103 34.439 14.5783V45.5393C34.439 46.4073 34.6834 47.0775 35.1059 47.508L35.2101 47.6025L53.0311 30.26V29.8505L35.2101 12.508L35.1059 12.6095Z",
			fill: "url(#paint0_linear_2651_32598)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.9694 36.0439L53.0356 30.2602V29.8507L58.9766 24.0669L59.1096 24.1422L66.1452 28.0394C68.1531 29.1454 68.1531 30.9654 66.1452 32.0784L59.1096 35.9687L58.9694 36.0439Z",
			fill: "url(#paint1_linear_2651_32598)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1062 35.9691L53.0322 30.0559L35.1069 47.5086C35.7738 48.1911 36.8614 48.2734 38.0981 47.5909L59.1062 35.9691Z",
			fill: "url(#paint2_linear_2651_32598)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.1062 24.1424L38.0981 12.5207C36.8614 11.8452 35.7738 11.9274 35.1069 12.6099L53.0322 30.0557L59.1062 24.1424Z",
			fill: "url(#paint3_linear_2651_32598)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.734 32.5097C122.357 32.5097 119.598 35.0122 119.598 38.4649C119.598 41.8897 122.357 44.4184 125.734 44.4184C129.119 44.4184 131.878 41.8897 131.878 38.4649C131.878 35.0122 129.119 32.5097 125.734 32.5097ZM125.734 42.0734C123.881 42.0734 122.287 40.5842 122.287 38.4649C122.287 36.3177 123.881 34.8547 125.734 34.8547C127.588 34.8547 129.189 36.3177 129.189 38.4649C129.189 40.5842 127.588 42.0734 125.734 42.0734ZM112.344 32.5097C108.96 32.5097 106.208 35.0122 106.208 38.4649C106.208 41.8897 108.96 44.4184 112.344 44.4184C115.727 44.4184 118.481 41.8897 118.481 38.4649C118.481 35.0122 115.727 32.5097 112.344 32.5097ZM112.344 42.0734C110.489 42.0734 108.889 40.5842 108.889 38.4649C108.889 36.3177 110.489 34.8547 112.344 34.8547C114.198 34.8547 115.792 36.3177 115.792 38.4649C115.792 40.5842 114.198 42.0734 112.344 42.0734ZM96.4108 34.3349V36.8654H102.618C102.436 38.2794 101.951 39.3189 101.207 40.0434C100.301 40.9184 98.8897 41.8896 96.4108 41.8896C92.591 41.8896 89.5999 38.8884 89.5999 35.1697C89.5999 31.4509 92.591 28.4497 96.4108 28.4497C98.4762 28.4497 99.979 29.2354 101.088 30.2539L102.92 28.4707C101.368 27.0287 99.3049 25.9209 96.4108 25.9209C91.1727 25.9209 86.7705 30.0702 86.7705 35.1697C86.7705 40.2692 91.1727 44.4184 96.4108 44.4184C99.242 44.4184 101.368 43.5154 103.04 41.8214C104.753 40.1536 105.287 37.8087 105.287 35.9152C105.287 35.3272 105.237 34.7864 105.147 34.3349H96.4108ZM161.565 36.2967C161.06 34.9649 159.502 32.5097 156.327 32.5097C153.181 32.5097 150.562 34.9229 150.562 38.4649C150.562 41.8004 153.154 44.4184 156.629 44.4184C159.439 44.4184 161.06 42.7506 161.727 41.7794L159.642 40.4267C158.946 41.4172 157.999 42.0734 156.629 42.0734C155.268 42.0734 154.292 41.4662 153.667 40.2692L161.847 36.9739L161.565 36.2967ZM153.224 38.2794C153.154 35.9834 155.056 34.8074 156.419 34.8074C157.487 34.8074 158.392 35.3272 158.694 36.0709L153.224 38.2794ZM146.575 44.0561H149.264V26.5562H146.575V44.0561ZM142.171 33.8362H142.081C141.477 33.1397 140.325 32.5097 138.866 32.5097C135.803 32.5097 133.002 35.1277 133.002 38.4842C133.002 41.8214 135.803 44.4184 138.866 44.4184C140.325 44.4184 141.477 43.7832 142.081 43.0657H142.171V43.9197C142.171 46.1964 140.922 47.4196 138.907 47.4196C137.264 47.4196 136.245 46.2646 135.824 45.2934L133.485 46.2436C134.16 47.8221 135.945 49.7646 138.907 49.7646C142.06 49.7646 144.72 47.9586 144.72 43.5644V32.8719H142.171V33.8362ZM139.096 42.0734C137.242 42.0734 135.691 40.5632 135.691 38.4842C135.691 36.3859 137.242 34.8547 139.096 34.8547C140.922 34.8547 142.362 36.3859 142.362 38.4842C142.362 40.5632 140.922 42.0734 139.096 42.0734ZM174.155 26.5562H167.724V44.0561H170.406V37.4254H174.155C177.134 37.4254 180.055 35.3272 180.055 31.9899C180.055 28.6544 177.127 26.5562 174.155 26.5562ZM174.225 34.9912H170.406V28.9904H174.225C176.228 28.9904 177.371 30.6092 177.371 31.9899C177.371 33.3444 176.228 34.9912 174.225 34.9912ZM190.804 32.4764C188.867 32.4764 186.851 33.3094 186.023 35.1557L188.403 36.1269C188.915 35.1557 189.857 34.8407 190.853 34.8407C192.244 34.8407 193.655 35.6544 193.677 37.0912V37.2749C193.191 37.0019 192.152 36.5977 190.874 36.5977C188.311 36.5977 185.699 37.9714 185.699 40.5352C185.699 42.8802 187.799 44.3904 190.159 44.3904C191.964 44.3904 192.96 43.5977 193.585 42.6754H193.677V44.0281H196.267V37.3152C196.267 34.2124 193.887 32.4764 190.804 32.4764ZM190.481 42.0664C189.604 42.0664 188.381 41.6429 188.381 40.5842C188.381 39.2297 189.905 38.7099 191.225 38.7099C192.406 38.7099 192.96 38.9637 193.677 39.2979C193.466 40.9184 192.034 42.0664 190.481 42.0664ZM205.704 32.8597L202.621 40.4459H202.53L199.343 32.8597H196.45L201.239 43.4611L198.507 49.3604H201.309L208.688 32.8597H205.704ZM181.529 44.0561H184.218V26.5562H181.529V44.0561Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.941 16.3972C95.941 17.5662 95.5815 18.5025 94.8732 19.2007C94.059 20.0285 92.9984 20.445 91.6988 20.445C90.4566 20.445 89.3961 20.0215 88.5261 19.1867C87.6542 18.3397 87.2192 17.3002 87.2192 16.056C87.2192 14.8117 87.6542 13.7722 88.5261 12.9322C89.3961 12.0905 90.4566 11.667 91.6988 11.667C92.3171 11.667 92.9067 11.7912 93.4694 12.0222C94.0302 12.255 94.4868 12.57 94.8175 12.9585L94.0661 13.697C93.4891 13.0337 92.7036 12.7065 91.6988 12.7065C90.7928 12.7065 90.0073 13.0145 89.3404 13.6357C88.6807 14.2587 88.3499 15.0655 88.3499 16.056C88.3499 17.0465 88.6807 17.8602 89.3404 18.4832C90.0073 19.0975 90.7928 19.4125 91.6988 19.4125C92.6605 19.4125 93.4694 19.0975 94.1075 18.4762C94.5281 18.065 94.7672 17.498 94.8301 16.7735H91.6988V15.762H95.8763C95.9266 15.9807 95.941 16.1925 95.941 16.3972Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M102.57 12.8901H98.646V15.5501H102.184V16.5616H98.646V19.2216H102.57V20.2524H97.5352V11.8594H102.57V12.8901Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.25 20.2524H106.139V12.8901H103.732V11.8594H109.659V12.8901H107.25V20.2524Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.943 20.2524V11.8594H115.052V20.2524H113.943Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.974 20.2524H118.872V12.8901H116.456V11.8594H122.39V12.8901H119.974V20.2524Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M133.608 19.1727C132.758 20.0215 131.704 20.445 130.448 20.445C129.184 20.445 128.131 20.0215 127.281 19.1727C126.432 18.3257 126.01 17.2862 126.01 16.056C126.01 14.8257 126.432 13.7862 127.281 12.9392C128.131 12.0905 129.184 11.667 130.448 11.667C131.697 11.667 132.751 12.0905 133.601 12.9462C134.457 13.8002 134.879 14.8327 134.879 16.056C134.879 17.2862 134.457 18.3257 133.608 19.1727ZM128.102 18.4692C128.742 19.0975 129.52 19.4125 130.448 19.4125C131.368 19.4125 132.154 19.0975 132.787 18.4692C133.425 17.841 133.748 17.0342 133.748 16.056C133.748 15.0777 133.425 14.271 132.787 13.6427C132.154 13.0145 131.368 12.6995 130.448 12.6995C129.52 12.6995 128.742 13.0145 128.102 13.6427C127.464 14.271 127.14 15.0777 127.14 16.056C127.14 17.0342 127.464 17.841 128.102 18.4692Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.435 20.2524V11.8594H137.783L141.975 18.3869H142.024L141.975 16.7734V11.8594H143.084V20.2524H141.927L137.537 13.4029H137.488L137.537 15.0234V20.2524H136.435Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .151864,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2651_32598",
				x1: 51.4488,
				y1: 45.8617,
				x2: 27.9619,
				y2: 21.7365,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#00A0FF" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .0066,
						stopColor: "#00A1FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .2601,
						stopColor: "#00BEFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5122,
						stopColor: "#00D2FF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7604,
						stopColor: "#00DFFF"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#00E3FF"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_2651_32598",
				x1: 68.7598,
				y1: 30.0535,
				x2: 33.9635,
				y2: 30.0535,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE000" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4087,
						stopColor: "#FFBD00"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7754,
						stopColor: "#FFA500"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#FF9C00"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_2651_32598",
				x1: 55.8033,
				y1: 26.8413,
				x2: 23.9532,
				y2: -5.87443,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF3A44" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#C31162"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_2651_32598",
				x1: 30.5948,
				y1: 57.809,
				x2: 44.8173,
				y2: 43.2001,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#32A071" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .0685,
						stopColor: "#2DA771"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .4762,
						stopColor: "#15CF74"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8009,
						stopColor: "#06E775"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#00F076"
					})
				]
			})
		] })
	]
});
export default SvgGoogleplayAppIcon;
